// Simple reducer to replace state in original FhwaFieldRowState class component
export enum ModalType {
  ADD_DEFECT = 'ADD_DEFECT',
  ADD_PROTECTIVE_COATING = 'ADD_PROTECTIVE_COATING',
  ADD_END_JOINT = 'ADD_END_JOINT',
  ADD_WEARING_SURFACE = 'ADD_WEARING_SURFACE',
  DELETE = 'DELETE',
  NONE = 'NONE',
}

export interface FhwaFieldRowState {
  environment: string;
  totalQuantity: number;
  remarks: string;
  cs1: number;
  cs2: number;
  cs3: number;
  cs4: number;
  cs1Percent: number;
  cs2Percent: number;
  cs3Percent: number;
  cs4Percent: number;
  openModal: { type: ModalType; markerId: number; id: any };
}

export const FhwaFieldRowStateReducer = (state: FhwaFieldRowState, action) => {
  switch (action.type) {
    case 'UPDATE_STATE':
      return { ...state, ...action.data };
    default: {
      return state;
    }
  }
};
